import TeamCard from './team-card'
export default TeamCard
